import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        width: '100%',
        paddingTop: theme.spacing(2),
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(3),
    },
    headerTitle: {
        fontSize: '1.75rem',
        fontWeight: 700,
    },
    summaryCard: {
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(3),
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: theme.spacing(3),
        marginBottom: theme.spacing(4),
    },
    summaryField: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.5),
    },
    summaryLabel: {
        fontSize: '0.75rem',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        color: theme.palette.text.secondary,
    },
    summaryValue: {
        fontSize: '1rem',
        fontWeight: 500,
        color: theme.palette.text.primary,
    },
    tableSection: {
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
    },
    sectionHeading: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(3),
    },
    sectionTitle: {
        fontSize: '1.35rem',
        fontWeight: 700,
        color: theme.palette.text.primary,
    },
    countChip: {
        fontWeight: 600,
        fontSize: '0.75rem',
        height: 22,
    },
}));
